export default __webpack_public_path__ + "static/media/benefits-landing-preview-desktop-v1.138fc48e.png";